<template>
<div>
    <animated-place-holder :height="'35px'" :width="'20%'" :borderradius="'10px'" ></animated-place-holder>
<animated-place-holder class="mt-2" :height="'35px'" :width="'100%'" :borderradius="'10px'" ></animated-place-holder>
<animated-place-holder class="mt-2" :height="'35px'" :width="'80%'" :borderradius="'10px'" ></animated-place-holder>
<animated-place-holder class="mt-2" :height="'35px'" :width="'100%'" :borderradius="'10px'"></animated-place-holder>
</div>
</template>

<script>
import AnimatedPlaceHolder from '@components/Skeleton/AnimatedPlaceHolder.vue'
export default {
  components: {
    'animated-place-holder': AnimatedPlaceHolder
  },
  data: function () {
    return {
      processing: false
    }
  }
}
</script>

<style>

</style>
